module.exports = {
      id: "my-vikatan-logo-usage",
      viewBox: "0 0 169.704 58.801",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#my-vikatan-logo",
      toString: function () {
        return this.url;
      }
    }